$ = require 'jquery'
Singleton = require '../../pattern/singleton'
Elements = require './elements'
Backbone = require 'backbone'
Data = require '../data'
XMLHttpRequest = require '../../components/xml-http-request'
PreloadImage = require '../../components/preload-image'
Deblurring = require './deblurring'
{ forEach, template, defaults, delay } = require 'lodash'
{ parse } = require '../../components/query-string'
{ getParams, getParam, addParam } = require './params'

module.exports =
class WorksList extends Singleton

  selector        : '.section-works .main-container'
  listSelector    : '.projects'
  loaderSelector  : '.loader'
  itemSelector    : 'li'
  prevSelector    : '.prev'
  nextSelector    : '.next'
  templateSelector: '.template-works-list'
  jsonUrl         : '/json/works.json'
  pageParams      : 'page'

  constructor: ->
    super

    @$window = Elements.$window
      .one
        'pagesLoaded': @onPagesLoaded
      .on
        'resize'       : @onWindowResized
        'firstAnimated': @onFirstAnimated

    @hasPushState = window.history and history.pushState
    @params       = getParams()
    @data         = []

    pageParams = @params[@pageParams]
    @page =
      if pageParams? then Number(pageParams) else 0

    @jsonLoad = new XMLHttpRequest @jsonUrl

    $.easeplus.addBackOut 'workListBackOut', .7
    $.easeplus.addBackOut 'workContollerBackOut', 8
    $.easeplus.addBackIn 'workContollerBackIn', 8

  load: =>
    @jsonLoad.request().then (data) =>
      if @isJson data
        data = JSON.parse data
      @onJsonLoaded data

  onPagesLoaded: =>
    @$main   = $ @selector
    @$list   = @$main.find @listSelector
    @$loader = @$main.find @loaderSelector
    @$prev   = @$main.find @prevSelector
      .on 'click', @prev
    @$next   = @$main.find @nextSelector
      .on 'click', @next
    @$tmp    = @$main.find @templateSelector

    @tmp = template @$tmp.html()

    @deblurring = new Deblurring @$main

  onWindowResized: =>
    @$winW  = @$window.width()
    @$listW = @$list.width()
    @shiftX = @getShiftX()

  onJsonLoaded: (data) ->
    do ->
      WorksList.data = data
      i = 0
      forEach WorksList.data, (data) ->
        data.id = i
        i++

    @$window.trigger 'worksJsonLoaded'

    @$winW  = @$window.width()
    @$listW = @$list.width()
    @shiftX = @getShiftX()

    count = 0
    index = 0

    forEach data, (v, k) =>
      @data[index] = {} unless @data[index]
      @data[index][k] = v
      count++
      index++ unless (count % 8)
    @dataLen = @data.length

    @setData @data[@page], =>
      @$window.trigger 'worksListLoaded'

  onFirstAnimated: (e, target) =>
    return if target isnt 3
    setTimeout =>
      @toggleController @page
    , 200

  getShiftX: ->
    @$listW + ((@$winW - @$listW) / 2)

  prev: =>
    @move @page - 1

  next: =>
    @move @page + 1

  move: (target) ->
    if @beforePage is target or
       !(0 <= target < @dataLen)
      return

    addParam 4, @pageParams, target
    query = $.param Data.params[4]
    pathname =
    if @hasPushState
      location.pathname
    else
      '/works/'
    Backbone.history.navigate "#{pathname}?#{query}", true
    ga 'send', 'pageview', "#{pathname}#{location.search}#{location.hash}"

  goTo: (target) =>
    @beforePage = @page
    return if @beforePage is target
    @page = target

    dir =
      if 0 < (target - @beforePage) then 1 else -1

    @toggleList [-@shiftX * dir],
      easing  : 'easeOutCubic'
      complete: =>
        @toggleLoader true,
          complete: =>
            @setData @data[target], =>
              @toggleLoader false,
                duration: 300
                complete: =>
                  @toggleList [0, @shiftX * dir],
                    easing  : 'workListBackOut'
                    complete: =>
                      @deblurring.redraw()
                      @beforePage = target

    @toggleController target

  setData: (data, cb) ->
    @$list
      .empty()
      .append @tmp { data: data }

    @preloadImage = new PreloadImage @listSelector
    @preloadImage
      .load()
      .then => cb()

    @$window.trigger 'worksListSetted'

  toggleList: (x, opts = {}) ->
    opts = defaults opts,
      duration: 500

    @$list
      .velocity 'stop'
      .velocity
        translateX: x
      , opts

  toggleLoader: (toggle, opts = {}) ->
    opts = defaults opts,
      duration: 300
      easing  : 'easeOutBack'

    if toggle
      scale        = [1, 0]
      opts.display = 'block'
    else
      scale        = [0, 1]
      opts.display = 'none'

    @$loader
      .velocity 'stop'
      .velocity
        scale: scale
      , opts

  toggleController: (target) ->
    return if 1 >= @dataLen

    if 0 >= target
      @controllerAnime @$prev, false
    else if @$prev.is ':hidden'
      @controllerAnime @$prev, true

    if (@dataLen - 1) <= target
      @controllerAnime @$next, false
    else if @$next.is ':hidden'
      @controllerAnime @$next, true

  controllerAnime: ($el, toggle) ->
    opts =
      duration: 200

    if toggle
      opacity       = [ 1, 0 ]
      scale         = [ 1, 0 ]
      opts.easing   = 'workContollerBackOut'
      opts.display  = 'block'
    else
      opacity       = [ 0, 1 ]
      scale         = [ 0, 1 ]
      opts.easing   = 'workContollerBackIn'
      opts.display  = 'none'

    $el
      .velocity 'stop'
      .velocity
        scale: scale
      , opts

  isJson: (arg) ->
    arg = if (typeof(arg) is 'function') then arg() else arg
    return false if typeof(arg) isnt 'string'
    try
      arg = if !JSON then eval("(" + arg + ")") else JSON.parse(arg)
      return true
    catch e
      return false



// WEBPACK FOOTER //
// ./webpack/requires/pc/views/works-list.coffee